import { Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
export const DrawerSubHeaderStyled = styled(Box).attrs({
  pl: { sm: '500' },
  pb: { sm: '500' },
  pt: { sm: '600' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[200]};
    border-bottom: 1px solid ${theme.colors.grey[300]};
    font-size: ${theme.fontSizes[400]};
    font-weight: ${theme.fontWeights[600]};
    font-family: ${theme.fontFamilies.graphik};
  `}
`;
